var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.typeData.class},[_c('span',{staticClass:"icon-mapit"},[_vm._v(_vm._s(_vm.typeData.icon))]),_c('div',{staticClass:"info-text",domProps:{"innerHTML":_vm._s(_vm.text)}})])}
var staticRenderFns = []

export { render, staticRenderFns }